module.exports = __webpack_public_path__ + "assets/img/solar-panels-cloudy-small.c30531dd.jpg";